import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import IntroTopSection from '../../../components/Introduction/IntroTopSection';
import IntroSubHeading from '../../../components/Introduction/IntroSubHeading';
import { FiEye, FiInbox } from 'react-icons/fi';
import { HomeService } from "../../../services";
import { formatDateToYYYYMMDD } from '../../../utils/dateUtils';
import defaultNewsImage from '../../../assets/img/customer-service-center/news-default-img.gif';

const MemorialGalleryListPC = () => {
  const navigate = useNavigate();
  const [galleryList, setGalleryList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);


  const fetchGalleryList = async (page = currentPage, append = false) => {
    try {
      setLoading(true);
      const apiData = await HomeService.getGalleryList({
        page: page,
        size: 9,
      });
      if (apiData.content.length > 0) {
        // Check for duplicate boardId before setting announcements
        const uniqueGalleryList = [];
        const seenBoardIds = new Set();

        // If appending, add existing announcements to the set
        if (append) {
          galleryList.forEach(item => seenBoardIds.add(item.galleryId));
        }

        for (const item of apiData.content) {
          if (!seenBoardIds.has(item.galleryId)) {
            uniqueGalleryList.push(item);
            seenBoardIds.add(item.galleryId);
          }
        }

        if (append) {
          setGalleryList(prev => [...prev, ...uniqueGalleryList]);
        } else {
          setGalleryList(uniqueGalleryList);
        }
      }
      setTotalPages(apiData.totalPages);
    } catch (err) {
      console.error('Failed to fetch announcements:', err);
    } finally {
      setLoading(false);
    }
  };

  // Initial load
  useEffect(() => {
    fetchGalleryList();
  }, []); // Only run on component mount

  const handleLoadMore = () => {
    if (currentPage < totalPages) {
      const nextPage = currentPage + 1;
      setCurrentPage(nextPage);
      fetchGalleryList(nextPage, true); // Append new announcements
    }
  };

  const handleGalleryClick = (galleryId) => {
    navigate(`/memorial-gallery-details/${galleryId}`);
  };

  return (
    <div className="announcement-list-page intro-info-page">

      <IntroTopSection />
      {/* Main Content */}
      <main className="main-content">
        <IntroSubHeading heading="추모원 갤러리" />

        <section className="announcement-section">
          {galleryList.length === 0 ? (
            <div className="empty-state">
              <FiInbox className="empty-icon" size={64} />
              <div className="empty-title">등록된 공지사항이 없습니다</div>
              <div className="empty-description">
                새로운 공지사항이 등록되면 이곳에 표시됩니다.
              </div>
            </div>
          ) : (
            <>
              <div className="announcement-grid">
                {galleryList.map((gallery) => (
                  <div
                    key={gallery.galleryId}
                    className="announcement-card clickable"
                    onClick={() => handleGalleryClick(gallery.galleryId)}
                  >
                    <div className="announcement-image">
                      <img
                        src={gallery.photoThumbUrl || defaultNewsImage}
                        alt={gallery.galleryTitle}
                        onError={(e) => {
                          e.target.src = defaultNewsImage;
                        }}
                      />
                    </div>
                    <div className="announcement-content">
                      <h3 className="announcement-title">
                        {gallery.galleryTitle}
                      </h3>
                      <div className="announcement-meta">
                        <span className="announcement-date">
                          {formatDateToYYYYMMDD(gallery.registTime)}
                        </span>
                        <span className="announcement-views">
                          <FiEye className="eye-icon" />
                          {gallery.readCount}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Load More Button */}
              {currentPage < totalPages && (
                <div className="more-button-section">
                  <button
                    className="more-button"
                    onClick={handleLoadMore}
                    disabled={loading}
                  >
                    {loading ? '로딩 중...' : '더보기'}
                  </button>
                </div>
              )}

            </>
          )}
        </section>
      </main>

    </div>
  );
};

export default MemorialGalleryListPC; 